export default __webpack_public_path__ + "static/media/icon-radio-input-checked-v1.8d8dfbc1.svg";